module.exports = __webpack_public_path__ + "img/file-earmark-plus.6bc4f707.svg";